/**
 * Clear activation status
 * @param {string} status
 * @returns {string} cleared status "fail"
 */
const clearActivationStatus = (status) => status.split(':')[1].trim().toLowerCase();

/**
 * Activation object
 * @param {object} cart Cart object
 * @param {object} activatedProduct Object with product data
 * @returns {object} SDL activation object
 */
export default (cart, activatedProduct) => ({
	system: {
		activation: {
			status: clearActivationStatus(activatedProduct.fulfillment.activation.status),
			productId: activatedProduct.id,
			activations: activatedProduct.fulfillment.activation.successCount,
			fActivations: activatedProduct.fulfillment.activation.failCount
		}
	},
	event: 'system.activation'
});
